<template>
  <li class="col-xs-6" style="padding:0 0 5px 5px;">
    <button @click="handleClick" type="button" :disabled="loading"
            :class="['btn', active === 1 ? 'btn-success btn-sm active' : 'btn btn-danger btn-sm', 'btn-block']">
      <i :class="['fa', loading ? 'fa-spinner fa-spin' : active === 1 ? 'fa-check' : 'fa-ban', 'mr-5']"></i>{{channel | translate}}
    </button>
  </li>
</template>

<script>
export default {
  name: "StoreTableRowButton",
  props: ['value', 'channel', 'store', 'isAdditionalMarketplaces'],
  data () {
    return {
      active: this.value,
      loading: false
    }
  },
  methods: {
    getChannelName (channel) {
      return channel === 'click_and_collect' ? 'ti_reserve_window' : channel === 'schuhe_de' ? 'ti_sale_window' : channel === 'spartoo' ? 'ti_mp_diverse' : channel
    },
    handleClick () {
      this.loading = true
      let newVal = this.active === 1 ? 0 : 1
      if (this.isAdditionalMarketplaces) {
        API.put(`statistics/stores/additionalMarketplaces/${this.store.gln}`, {"channel": this.getChannelName(this.channel), "value": newVal})
          .then(response => {
            this.active = newVal
            this.loading = false
          }).catch(error => {
          this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error.response.data.message, icon: 'fa fa-ban', show: true})
          this.loading = false
        })
      } else {
        API.put(`accounting/companies/${this.$route.params.id}/stores/mp`, {'store_id': this.store.id,"channels": {[this.getChannelName(this.channel)]: newVal}})
          .then(response => {
            this.active = newVal
            this.loading = false
          }).catch(error => {
          this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error.response.data.message, icon: 'fa fa-ban', show: true})
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/TableRows/StoreTableRowButton.vue